export default "<div data-bind=\"component: { name: view, params: { route: route, dataProvider: dataProvider } }\"></div>";